import { SignUpPage } from '@/common/containers/Authentication/SignupPage/SignupPage';
import { useFeatures } from '@/common/integrations/feature-flag/feature-flag.hooks';
import { SignUp } from '@/web/containers/Authentication/containers/SignUp/SignUp';

export default function Page() {
  const {
    features: { ff_sea_authentication },
  } = useFeatures();

  if (ff_sea_authentication) {
    return <SignUpPage />;
  }

  return <SignUp />;
}
